/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quantity_BagsInputs */

const en_quantity_bags = /** @type {(inputs: Quantity_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity (bags)`)
};

const es_quantity_bags = /** @type {(inputs: Quantity_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad (bolsas)`)
};

/**
* | output |
* | --- |
* | "Quantity (bags)" |
*
* @param {Quantity_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const quantity_bags = /** @type {((inputs?: Quantity_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quantity_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quantity_bags(inputs)
	return es_quantity_bags(inputs)
});